import BaseIntegrationIcon from "@/components/reusables/BaseIntegrationIcon";
import BaseDropdown from "@/components/reusables/dropdowns/BaseDropdown";
import { isSystemIntegratedSelector } from "@/redux/features/auth/authSlice";
import { useGetTwentyFourSevenOfficeProjectsQuery } from "@/redux/features/integrations/integrationsApi";
import { useAppSelector } from "@/redux/hooks";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SaleOrdersFormTyping } from "../../types";

export default function TwentyFourSevenOfficeProjectsDropdown() {
    const { t } = useTranslation("", {
        keyPrefix: "sales.orders.integrations.fields.project",
    });

    const { control } = useFormContext<SaleOrdersFormTyping>();

    const isIntegrated = useAppSelector(isSystemIntegratedSelector("twenty_four_seven_office"));

    const { data: projects, isFetching } = useGetTwentyFourSevenOfficeProjectsQuery(
        undefined,
        { skip: !isIntegrated } // Note: using skip here, because if we change this value to true without page reload (e.g., via sockets), the number of hooks should stay the same
    );

    if (!isIntegrated) return null;

    return (
        <Controller
            name="twenty_four_seven_office.project"
            control={control}
            render={({ field, fieldState }) => (
                <BaseDropdown
                    {...field}
                    {...fieldState}
                    label={
                        <div className="flex items-center space-x-2">
                            <BaseIntegrationIcon integration="twenty_four_seven_office" />
                            <span>{t("label")}</span>
                        </div>
                    }
                    placeholder={t("placeholder")}
                    options={projects}
                    getter={{
                        key: (project) => project.id,
                        label: (project) => project.name,
                    }}
                    autocomplete
                    isLoading={isFetching}
                />
            )}
        />
    );
}
